<template>
	<div class="shuttle_table filter_table">
		<div class="table_tip flex flex_between" :class="`${shuttleType}`">
			<div>
        <span class="data_num">
          {{ $t("investorsList.table.type." + this.shuttleType) }}
          {{ $t("common.investors") }}
        </span>
			</div>
			<div v-if="shuttleType==='unChecked'" class="einblenden_icon" @click="changeEinblenden">
				<i class="el-icon-arrow-right" :class="einblenden?'einblenden':'ausblenden'"></i>
				{{ !einblenden ? $t("common.show") : $t("common.hide") }}
			</div>
		</div>
		<div v-show="(shuttleType==='unChecked'&&einblenden)||shuttleType!=='unChecked'">
			<ag-item
				:class="`${shuttleType}`"
				:rowData="rowData"
				:columnDefs="columnDefs"
				v-on:getGridApi="getGridApi"
				v-on:sortChanged="sortChanged"
				height="300px"
				:withBorder="false"
			></ag-item>
		</div>
	</div>
</template>

<script>
import AgItem from "@/components/templates/agGrid/AgItem.vue";
import enumStatus from "@/common/enum";
import {whitelistApi} from "@/common/api/whitelistApi";
import {asIndustryText} from "@/components/templates/agGrid/formatter/valueFormatters";

export default {
	props: {
		shuttleType: { type: String, default: "unChecked" },
		filters: { type: Array, default: [] },
	},
	components: { AgItem },
	data() {
		return {
			columnDefs: [],
			frameworkComponents: null,
			rowData: [],
			sorting: [],
			recordsTotal: 0,
			einblenden: false,
		};
	},
	beforeMount() {
		this.getList();
		this.setColumnDefs();
	},
	methods: {
		changeEinblenden() {
			this.einblenden = !this.einblenden;
			this.$emit("einblenden", this.einblenden);
		},
		getGridApi(api) {
			this.$emit("getGridApi", { api: api, type: this.shuttleType });
		},
		setColumnDefs() {
			this.columnDefs = [
				{
					minWidth: 45,
					maxWidth: 45,
					checkboxSelection: true,
					headerCheckboxSelection: true,
					headerCheckboxSelectionFilteredOnly: true
				},
				{
					headerName: this.$t("common.company"),
					field: "name",
					minWidth: 200,
					flex: 1,
					filter: false,
					nameType: "name",
					idType: "id",
					sortable: true,
					cellRendererFramework: "CompanyTem"
				},
				{
					headerName: this.$t("common.industry"),
					field: "industry",
					minWidth: 250,
					flex: 1,
					valueFormatter: asIndustryText(),
					cellRendererFramework: "GeneralShortenedDisplay",
					sortable: true,
				},
				{
					headerName: this.$t("common.subIndustry"),
					field: "subIndustry",
					minWidth: 300,
					flex: 1,
					valueFormatter: asIndustryText(),
					cellRendererFramework: "GeneralShortenedDisplay",
					sortable: true,
				},
				{
					headerName: this.$t("common.country"),
					field: "country",
					minWidth: 100,
					sortable: true
				},
				{
					headerName: this.$t("revolvingPutOption.optionProvider"),
					field: "canBePutOptionProvider",
					minWidth: 175,
					cellRendererFramework: "BooleanAsIcon",
					sortable: true,
				}
			];
		},
		sortChanged(sortData) {
			this.sorting = sortData;
			this.getList();
		},
		getList() {
			let tableType = this._.filter(enumStatus.InvestorTableList, item => {
				return item.shuttleType === this.shuttleType;
			});

			let postData = {
				columns: [],
				filters: this.filters || [],
				maxResults: 10000,
				offset: 0,
				sorting: this.sorting
			};

			whitelistApi[tableType[0].type](postData)
				.then(res => {
					if (this.recordsTotal === 0 && res.recordsTotal > 0) {
						this.changeEinblenden();
					}
					this.recordsTotal = res.recordsTotal;
					this.rowData = res.data;
				})
				.catch(err => {
					this.toast(err);
				});
		}
	},
	watch: {
		filters() {
			this.getList();
		}
	}
};
</script>

<style lang="scss" scoped>
	@import "investor.scss";

	.einblenden_icon {
		cursor: pointer;

		.einblenden {
			transform: rotate(90deg);
			transition: all 0.5s;
		}
	}
</style>
